import type { LucideIcon } from "lucide-react";

/** Presentation only: callers own the value's scope and evidence qualification. */
export function ReportingMetricCard({ label, value, icon: Icon, tone }: {
  label: string; value: string; icon: LucideIcon; tone: string;
}) {
  return <div data-testid="account-metric-card" className="flex min-h-[76px] min-w-0 flex-grow basis-[min(100%,max(180px,calc(20%-0.4rem)))] items-center gap-2.5 rounded-lg border border-border/70 bg-background/80 p-3 shadow-[0_1px_2px_rgba(55,45,85,0.06)]">
    <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg ${tone}`}><Icon aria-hidden="true" className="h-4 w-4" /></span>
    <div className="min-w-0">
      <div className="text-xs font-medium leading-4 text-muted-foreground">{label}</div>
      <div className="mt-0.5 break-words text-lg font-bold leading-6 tracking-tight text-foreground">{value}</div>
    </div>
  </div>;
}
